import OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersOrderTableColumn from "../../types/order-optimizer-cargo-details-hidden-details-center-tables-orders-order-table-column";

const getColumns =
  (): OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersOrderTableColumn[] => {
    const tableColumns: OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersOrderTableColumn[] =
      [
        {
          header: "",
          title: "",
          accessor: "humanId",
          colSpan: 2,
        },
        {
          header: "",
          title: "",
          accessor: "address",
          colSpan: 5,
        },
        {
          header: "",
          title: "",
          accessor: "time",
          colSpan: 3,
        },
        {
          header: "",
          title: "",
          accessor: "haltingTime",
          colSpan: 3,
        },
        {
          header: "",
          title: "",
          accessor: "distance",
          colSpan: 2,
        },
        {
          header: "",
          title: "",
          accessor: "actions",
          colSpan: 1,
        },
      ];

    return tableColumns;
  };

const orderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersOrderTableHelper =
  {
    getColumns,
  };

export default orderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersOrderTableHelper;
